<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="originData.accState === 1 ? '冻结' : '解冻'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <el-alert
        :closable="false"
        :title="
          originData.accState === 1 ?
          '账户冻结后，司机将不能使用您推送的油、ETC及预支尾款。' :
          '确定解冻该账户？账户解冻后，司机将可以随意支配资金。'
        "
        type="warning" />
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  changeAccountStatus,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '原因',
            value: 'remark',
            type: 'input',
            placeholder: '请输入原因',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: { // 表单验证规则
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.originData = item;
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await changeAccountStatus({
        state: this.originData.accState === 1 ? 0 : 1,
        sourceTenantId: this.originData.sourceTenantId,
        userId: this.originData.userId,
        userType: this.originData.userType,
        remark: form.remark,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
